// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2R5Jc","form":"styles_form__k97Fk"};